var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Navbar'),_c('v-main',[_c('router-view'),_c('Snackbar')],1),_c('v-divider'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }